/**
 * Common Translations Module
 */
import { commonPt } from './pt'
import { commonEn } from './en'

export const common = {
  pt: commonPt,
  en: commonEn,
}
